import React from 'react';
import './desc.css';
import tick from "../../assets/tick.png";
import { Btn } from '../../utils/utils';
import { ArrowRight } from 'iconsax-react';

const DescComp = ({title, text, image, descArr, descBg, color}) => {

  return (
    <div className='desc-cont' style={{background: descBg}}>
    <div className='desc'>
        <div className="desc-left">
            <h3 style={{color: color && "#080B24"}}>{title}</h3>
            <h4 style={{color: color && "#080B24"}}>{text}</h4>
            <div className="reasons">
                {descArr.map((item, i) => {
                    return (
                        <div key={i} className="each-reason">
                            <img src={tick} alt="tick" />
                            <p style={{color: color && "#080B24"}}>{item.ques}<span>{item.ans}</span></p>
                        </div>
                    )
                })}
            </div>
    <div className="desc-btn">
        <Btn btnLink={"/"} btnText={"Learn more"} btnClass={"home-btn"} rightIcon={<ArrowRight size={20} />} />
    </div>
        </div>
        <div className="desc-right">
            <img src={image} alt="desc" />
        </div>
    </div>
    </div>
  )
}

export default DescComp